'use client'

import { useState } from 'react'
import { CircleCheck } from 'lucide-react'
import { Button } from '@/core/components/button'
import { Card, CardContent } from '@/core/components/card'

const membersBenefits = [
  'Connect locally',
  'Shop trusted goods & services',
  'AI-curated matches',
  'Tag anything',
] as const

const businessBenefits = [
  'Targeted exposure',
  'Join the convo',
  'Earn trust, not clicks',
  'Pay only on results',
] as const

export function BenefitsToggle() {
  const [activeTab, setActiveTab] = useState<'members' | 'businesses'>('members')
  const benefits = activeTab === 'members' ? membersBenefits : businessBenefits

  return (
    <section className="py-20 bg-soft-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-5xl font-bold text-navy mb-8">
            Why People Love Hiving Together
          </h2>
          <div className="inline-flex bg-card rounded-xl p-2 shadow-card">
            <Button
              variant={activeTab === 'members' ? 'cta-primary' : 'ghost'}
              onClick={() => setActiveTab('members')}
              className="px-8 py-3"
            >
              Members
            </Button>
            <Button
              variant={activeTab === 'businesses' ? 'cta-primary' : 'ghost'}
              onClick={() => setActiveTab('businesses')}
              className="px-8 py-3"
            >
              Businesses
            </Button>
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {benefits.map((benefit) => (
            <Card
              key={benefit}
              className="shadow-card hover:shadow-card-hover transition-all duration-300"
            >
              <CardContent className="p-8">
                <div className="flex items-center space-x-4">
                  <div className="flex-shrink-0">
                    <CircleCheck className="w-8 h-8 text-accent" />
                  </div>
                  <span className="text-lg font-semibold text-navy">{benefit}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}
